var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "eu-py_3" }, [
    _c(
      "div",
      {
        staticClass: "emd-filter-dash",
        class: { _advanced: _vm.advancedOpened },
      },
      [
        _c(
          "div",
          { staticClass: "emd-filter-dash__basic" },
          [
            _c("basic-filter", {
              ref: "basicFilter",
              attrs: {
                advancedIsOpenned: _vm.advancedOpened,
                loadingList: _vm.loadingList,
                origin: _vm.origin,
                sendFilterEvents: _vm.sendFilterEvents,
                placeholder: _vm.placeholder,
                shortcutProp: _vm.shortcutProp,
                showShortcutCustomer: _vm.showShortcutCustomer,
              },
              on: { basicSearch: _vm.search },
              nativeOn: {
                click: function ($event) {
                  return _vm.interactedFilter("filter")
                },
              },
            }),
            _c("div", { staticClass: "emd-filter-dash__buttons" }, [
              _c(
                "div",
                [
                  _c("emd-tippy", {
                    attrs: {
                      id: "new-filter",
                      isHidden: !_vm.showTooltip.filter || _vm.advancedOpened,
                      destroy: !_vm.showTooltip.filter,
                      title: _vm.$t("tooltip.new-filter.title"),
                      description: _vm.$t("tooltip.new-filter.text"),
                      type: "template",
                      position: "left",
                    },
                    on: {
                      destroy: function ($event) {
                        return _vm.closeTooltip("filter")
                      },
                    },
                  }),
                  _c(
                    "span",
                    {
                      staticClass: "eu-position_relative emd-tippy-template",
                      attrs: { "data-template": "tooltip-new-filter" },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "emd-filter-dash__trigger",
                          class: { _active: _vm.advancedOpened },
                          attrs: {
                            "data-testid": "dropdown-advanced-filter",
                            alt: _vm.$t("alt-filters"),
                          },
                          on: { click: _vm.toggleAdvanced },
                        },
                        [
                          _c("i", { staticClass: "uil uil-filter" }),
                          _vm._v(" " + _vm._s(_vm.$t("filters")) + " "),
                        ]
                      ),
                      _vm.totalQueries > 0
                        ? _c(
                            "span",
                            { staticClass: "emd-filter-dash__counter" },
                            [_vm._v(_vm._s(_vm.totalQueries))]
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "eu-display_flex eu-align-items_center" },
                [
                  _c("period-filter", {
                    ref: "periodFilter",
                    attrs: { loadingList: _vm.loadingList },
                    on: { dateFiltersChanged: _vm.search },
                  }),
                  _c(
                    "div",
                    { staticClass: "eu-ml_3" },
                    [
                      _c(
                        "emd-tippy",
                        {
                          staticClass: "emd-tippy-action-button _update-list",
                          attrs: {
                            id: "update-list",
                            type: "action-button",
                            content: _vm.$t("update-list"),
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "emd-action-button _lvl_2 _square _size_small _has-tooltip",
                              class: { _disabled: _vm.loadingList },
                              on: { click: _vm.update },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "emd-text _color_default emd-action-button__icon",
                                  attrs: { "data-testid": "btn_update_orders" },
                                },
                                [_c("i", { staticClass: "uil uil-sync" })]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "eu-mr_3" },
                    [_vm._t("extraActions")],
                    2
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
        _c("hr", { staticClass: "emd-divider" }),
        _c("advanced-filter", {
          ref: "advancedFilter",
          attrs: {
            options: _vm.options,
            loadingList: _vm.loadingList,
            origin: _vm.origin,
            sendFilterEvents: _vm.sendFilterEvents,
          },
          on: { advancedSearch: _vm.search, setTabbar: _vm.setTabbar },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }